// extracted by mini-css-extract-plugin
export default {"colors":"PalettePanel_colors__R3G6c","row":"PalettePanel_row__040jX","key":"PalettePanel_key__hIiEZ","val":"PalettePanel_val__lhdDV","clr":"PalettePanel_clr__YhMbV"};